import { render, staticRenderFns } from "./FairView.vue?vue&type=template&id=5ae19298"
import script from "./FairView.vue?vue&type=script&lang=js"
export * from "./FairView.vue?vue&type=script&lang=js"
import style0 from "./FairView.vue?vue&type=style&index=0&id=5ae19298&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports